<template>
  <div v-if="item.hidden !== '1'">
    <template v-if="(hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren) && !item.alwaysShow) || item[treeConfig.leafField]">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)" :route="item">
        <el-menu-item :disabled="isExternalFun(item)" :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest, 'no-disabled': isExternalFun(item)}">
          <item :popObj="getPopObj(item)" :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title"/>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <span class="parent-dot" v-if="showDot(item)"></span>
        <item v-if="item.meta" :popObj="getPopObj(item)" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from "path"
import { isExternal } from "@/utils/validate"
import Item from "./Item"
import AppLink from "./link"
import FixiOSBug from "./fixiOSBug"

export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {
      
    }
  },
  computed: {
    treeConfig() {
      return this.$store.state.user.treeConfig
    },
    sidePopObj() {
      return this.$store.state.user.sidePopObj
    }
  },
  methods: {
    isExternalFun(item) {
      if (isExternal(item.path)) {
        return true
      }
      if (item.children && isExternal(item.children[0].path)) {
        return true
      }
      return false
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden === "1") {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // 当只有一个子路由器时，默认情况下会显示子路由器
      if (showingChildren.length === 1) {
        return true
      }

      //如果没有要显示的子路由器，则显示父路由器
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: "", noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    /**
     * @description: 获取气泡
     * @param {*} item
     * @return {*}
     * @author: syx
     */  
    getPopObj(item) {
      return this.sidePopObj[item.name] || {}
    },
    // 子元素是否有气泡
    showDot(item) {
      const _this = this
      const doesChildHasSign = function(tree) {
        for (const node of tree) {
          if (_this.sidePopObj[node.name] && _this.sidePopObj[node.name].popType !== "none") {
            return true
          }
          if (node.children && node.children.length > 0) {
            const result = doesChildHasSign(node.children)
            if (result) {
              return result
            }
          }
        }
        return false
      }
      return doesChildHasSign(item.children)
    }
  }
}
</script>
